/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Кэш параметров окна top|left|bottom|right|width|height
   * @type {Object}
   */
  var windowCache = {};
  /**
   * Массив отслеживаемых вью
   * @type {Array}
   */
  var mixedViews = [];
  /**
   * Функциональность реакции на попадание в поле зрения пользователя.
   */
  app.InViewPortMixin = {
    afterRun: function () {
      this.cache = {};
      /*
       * модель по которой отслеживаем изменение попадания во viewport
       * изначально считаем что объект не попадает во viewport
       */
      this.viewPortModel = new app.Model({ in: false });
      if (mixedViews.length === 0) {
        // реагируем на скролинг
        Backbone.listenTo(app.mainWindow, 'window.scroll', this.showListening.bind(this));
        // реагируем на измерение размеров окна
        Backbone.listenTo(app.mainWindow, 'window.resize', this.onResize.bind(this));
        // реагирует на окончание загрузки
        Backbone.listenTo(app.mainWindow, 'window.load', this.showListening.bind(this));
      }
      // состояние попадания во viewport изменилось
      this.listenTo(this.viewPortModel, 'change:in', this.changeViewport);
      mixedViews.push(this);
    },

    /**
     * Убираем вью из массива, используемого для проверки видимости элемента при скролле/изменении размера окна
     */
    stopViewportListening: function () {
      if (_.isFunction(this.getViewPortIdentifier)) {
        var currentIdentifier = this.getViewPortIdentifier();
        if (currentIdentifier) {
          mixedViews = mixedViews.filter(function (view) {
            return view.getViewPortIdentifier() !== currentIdentifier;
          });
        }
      } else {
        throw new Error('getViewPortIdentifier is not a function');
      }
    },

    /**
     * При изменении размеров окна скидывается кэш параметров окна
     * и отслеживаемых элементов, вызывается метод для отслеживания видимости
     */
    onResize: function () {
      windowCache = {};
      mixedViews.forEach(function (view) {
        view.cache = {};
        return view;
      });
      this.showListening();
    },
    /**
     * При скролле или изменении размеров окна определяется
     * входят ли отслеживаемые элементы в поле видимости
     */
    showListening: function () {
      if (!Array.isArray(mixedViews) || mixedViews.length < 1) {
        return;
      }
      // Вычисление параметров окна
      var $window = app.mainWindow.$el;
      var windowTop = $window.scrollTop(),
        isChangedWindowTop = windowCache.top === undefined || windowCache.top !== windowTop;
      var windowParams = isChangedWindowTop ? this._getWindowParams($window, windowTop) : windowCache;
      mixedViews.forEach(function (view) {
        if (!view.$el.length) {
          return;
        }
        /**
         * флаг попадания элемента в зону видимости (элементы не занимающие место
         * и полностью прозрачные не считаются попадающими во viewport)
         */
        var visible = view._checkElementIsVisible(view, windowParams, isChangedWindowTop);
        // устанавливаем флаг попадания во viewport
        view.viewPortModel.set({ in: visible });
      });
    },

    /**
     * Проверка видимости элемента в окне браузера
     * @param {app.ChponkView} view Вью баннера
     * @param {Object} windowParams Параметры окна
     * @param {boolean} isChangedWindowTop Изменились ли параметры окна
     * @return {boolean} Виден ли элемент
     */
    _checkElementIsVisible: function (view, windowParams, isChangedWindowTop) {
      var elWithParents = view.$el.parents().add(view.$el);
      var opaqueFilter = function (index, el) {
        return $(el).css('opacity') == 0;
      };
      var isOpaque = elWithParents.filter(opaqueFilter).length === 0,
        isVisible = view.$el.is(':visible'),
        isInViewport = false;
      if (isOpaque && isVisible) {
        isInViewport = view._checkElementInViewPort(view, elWithParents, windowParams, isChangedWindowTop);
      }
      return isVisible && isOpaque && isInViewport;
    },

    /**
     * Проверка элемента на нахождение во вьюпорте
     * @param {app.ChponkView} view Вью баннера
     * @param {Array} elWithParents Массив родительских элементов вместе с самим элементом
     * @param {Object} windowParams Параметры окна
     * @param {boolean} isChangedWindowTop Изменились ли параметры окна
     * @returns {boolean}
     */
    _checkElementInViewPort: function (view, elWithParents, windowParams, isChangedWindowTop) {
      var elCache = view.cache.element || {},
        parentCache = view.cache.parent || {},
        viewportCache = view.cache.viewport || {},
        isChangeParentPosition = false,
        overflowParentParams = parentCache;

      // Вычисление позиции элемента
      var elOffset = view.$el.offset() || { left: 0, top: 0 },
        isChangeElPosition = elOffset.top !== elCache.top || elOffset.left !== elCache.left;
      var elParams = isChangeElPosition ? view._getElementParams(view.$el, elCache, elOffset, 'element') : elCache;

      if (isChangeElPosition) {
        // Вычисление позиции родительского элемента с overflow
        var $parentWithOverflow = elWithParents.filter(function (index, el) {
          var $parent = $(el);
          return $parent.css('overflow') === 'hidden'
            || $parent.css('overflow-x') === 'hidden'
            || $parent.css('overflow-y') === 'hidden';
        });
        if ($parentWithOverflow.length) {
          var lastParent = $parentWithOverflow.last(),
            parentOffset = lastParent.offset() || {left: 0, top: 0};
          isChangeParentPosition = parentOffset.top !== parentCache.top || parentOffset.left !== parentCache.left;
          if (isChangeParentPosition) {
            overflowParentParams = view._getElementParams(lastParent, parentCache, parentOffset, 'parent');
          }
        }
      }
      /*
       * координаты текущей области просмотра
       * c учётом наличия родителей с overflow: hidden
       */
      var viewport = isChangedWindowTop || isChangeParentPosition
        ? view._getViewportParams(windowParams, overflowParentParams)
        : viewportCache;
      return !(
        viewport.right <= elParams.left
        || viewport.left >= elParams.right
        || viewport.bottom <= elParams.top
        || viewport.top >= elParams.bottom
      );
    },

    /**
     * Получение новых параметров элемента
     * @param {jQuery} el Элемент
     * @param {Object} cache Текущие кэшированные данные элемента
     * @param {Object} offset Новое значение offset-а
     * @param {string} cacheName Наименование кэша 'element'|'parent'
     * @returns {{
     *   top: integer,
     *   left: integer,
     *   bottom: integer,
     *   width: integer,
     *   right: integer,
     *   height: integer
     * }}
     * @private
     */
    _getElementParams: function (el, cache, offset, cacheName) {
      var isParent = cacheName === 'parent',
        height = cache && cache.height,
        width = cache && cache.width;
      if (!height || !width) {
        height = isParent ? el.innerHeight() : el.outerHeight();
        width = isParent ? el.innerWidth() : el.outerWidth();
      }
      return this.cache[cacheName] = this._getPositionParams(offset, height, width);
    },

    /**
     * Получение новых параметров окна
     * @param {jQuery} $window Окно браузера
     * @param {integer} windowTop Количество прокрученных пикселей
     * @returns {{
     *   top: integer,
     *   left: integer,
     *   bottom: integer,
     *   width: integer,
     *   right: integer,
     *   height: integer
     * }}
     * @private
     */
    _getWindowParams: function ($window, windowTop) {
      var offset = {
          top: windowTop,
          left: windowCache.left || $window.scrollLeft(),
        },
        height = windowCache.height || $window.height(),
        width = windowCache.width || $window.width();
      return windowCache = this._getPositionParams(offset, height, width);
    },

    /**
     * Расчет параметров для сохранения в кэше
     * @param {Object} offset Значение offset-а
     * @param {integer} height Значение высоты
     * @param {integer} width Значение ширины
     * @returns {{
     *   top: integer,
     *   left: integer,
     *   bottom: integer,
     *   width: integer,
     *   right: integer,
     *   height: integer
     * }}
     * @private
     */
    _getPositionParams: function (offset, height, width) {
      return {
        top: offset.top,
        left: offset.left,
        right: offset.left + width,
        bottom: offset.top + height,
        height: height,
        width: width,
      };
    },

    /**
     * Получение параметров вьюпорта
     * @param {Object} windowParams Параметры окна
     * @param {Object} parentParams Параметры родительского элемента с overflow: hidden
     * @returns {{top: integer, left: integer, right: integer, bottom: integer}}
     * @private
     */
    _getViewportParams: function (windowParams, parentParams) {
      // координаты текущей области просмотра
      var viewport = windowParams;

      if (parentParams) {
        var intersectionBox = {
          left: Math.max(viewport.left, parentParams.left),
          top: Math.max(viewport.top, parentParams.top),
          right: Math.min(viewport.right, parentParams.right),
          bottom: Math.min(viewport.bottom, parentParams.bottom),
        };
        if (
          intersectionBox.left < intersectionBox.right
          && intersectionBox.top < intersectionBox.bottom
        ) {
          viewport = intersectionBox;
        }
      }
      this.cache.viewport = viewport;
      return viewport;
    },

    changeViewport: function (e) {
      if (e.get('in')) {
        // попал во viewport
        this.inViewPort();
      } else {
        // вышел из viewport
        this.outViewPort();
      }
    },
  };
})();

}.call(window));